import React__default from 'react';
import classNames from 'classnames';
import Styles from '../common.module.scss.js';
import { ReactComponent as SvgAngleLeft } from '../../../icons/AngleLeft.svg.js';

const LeftBtn = ({ className, style, iconClassName, iconStyle, onClick, disabled = false }) => {
    return (React__default.createElement("span", { className: classNames(Styles.main, Styles.right, disabled && Styles.disabled, className), style: style, onClick: onClick },
        React__default.createElement("span", { className: classNames(Styles.icon, iconClassName), style: iconStyle },
            React__default.createElement(SvgAngleLeft, null))));
};

export { LeftBtn as default };
//# sourceMappingURL=RightBtn.js.map
